// extracted by mini-css-extract-plugin
export default {"title":"ChooseDocumentType_title","actions":"ChooseDocumentType_actions"};